import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FlowBaseInfo } from '../../../ts/models/FlowInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { BasicField } from './Elements/BasicField';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Tags } from './Elements/Tags';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from './TooltipHelper';


export function FlowTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const flowInfo = content as FlowBaseInfo;
  const projectLink = getProjectLink(flowInfo.project, urls);
  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                  testId={TooltipDescriptionTestId}
                  extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={props.content.tags} />
      <BasicField name={Messages.inputSteps()} value={flowInfo.inputCount} />
      <BasicField name={Messages.outputSteps()} value={flowInfo.outputCount} />
      {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} /> }
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
